<header
    data-ui-view="header"
    class="header header--no-shadow ng-scope"
    [ngClass]="{
        'header__menu--push-right': pushedRight,
        'push-to-left': pushedLeft
    }"
>
    <div class="container header--no-shadow header--left-transition ng-scope">
        <div class="grid-container grid-container--section">
            <div class="grid-3 grid-mobile-4">
                <span class="site-logo"></span>
            </div>
            <nav class="header-nav grid-9 grid-mobile-4">
                <ul *ngIf="isAuthorizedForDisplay()" class="header-navList">
                    <li
                        appHeaderDocuments
                        #appHeaderDocuments
                        class="header-navItem ng-scope"
                        (toggleRightMenuMobile)="pushedLeft = !pushedLeft; toggleRightMenuMobile.emit()"
                        (toggleDocuments)="toggleNoscroll.emit()"
                        [appTagCommander]="'tagCo.header.documents.button'"
                    ></li>
                    <li
                        appHeaderProfile
                        data-tag-commander=""
                        class="header-navItem ng-scope"
                        (toggleLeftMenuMobile)="pushedRight = !pushedRight; toggleLeftMenuMobile.emit()"
                        (toggleNoscroll)="toggleNoscroll.emit()"
                        (logoutRequested)="hideEspaceDoc()"
                    ></li>
                </ul>
            </nav>
        </div>
    </div>
</header>
